"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Platform = exports.PopupEvent = void 0;
var PopupEvent;
(function (PopupEvent) {
    PopupEvent["PROJECT_APPROVED"] = "PROJECT_APPROVED";
    PopupEvent["HANDSHAKE"] = "HANDSHAKE";
    PopupEvent["HANDSHAKE_ACK"] = "HANDSHAKE_ACK";
    PopupEvent["SIGNED_TRANSACTION"] = "SIGNED_TRANSACTION";
    PopupEvent["SIGNED_PARTIAL_TRANSACTION"] = "SIGNED_PARTIAL_TRANSACTION";
    PopupEvent["FAILED_TO_SIGN_TRANSACTION"] = "FAILED_TO_SIGN_TRANSACTION";
    PopupEvent["TRANSACTION_DENIED"] = "TRANSACTION_DENIED";
    PopupEvent["SOLANA_WALLET_ADAPTER_APPROVED"] = "SOLANA_WALLET_ADAPTER_APPROVED";
    PopupEvent["SOLANA_WALLET_ADAPTER_DENIED"] = "SOLANA_WALLET_ADAPTER_DENIED";
    PopupEvent["POPUP_CLOSED"] = "POPUP_CLOSED";
    PopupEvent["TRANSACTION_SIGNATURE_NEEDED"] = "TRANSACTION_SIGNATURE_NEEDED";
    PopupEvent["TRANSACTION_SIGNATURE_NEEDED_RESPONSE"] = "TRANSACTION_SIGNATURE_NEEDED_RESPONSE";
    PopupEvent["AUTH_LOADED"] = "AUTH_LOADED";
    PopupEvent["MESSAGE_SIGNATURE_NEEDED"] = "MESSAGE_SIGNATURE_NEEDED";
    PopupEvent["MESSAGE_SIGNATURE_NEEDED_RESPONSE"] = "MESSAGE_SIGNATURE_NEEDED_RESPONSE";
    PopupEvent["ONRAMP_FULFILLMENT_COMPLETE"] = "ONRAMP_FULFILLMENT_COMPLETE";
    PopupEvent["ONRAMP_REJECTED"] = "ONRAMP_REJECTED";
})(PopupEvent = exports.PopupEvent || (exports.PopupEvent = {}));
var Platform;
(function (Platform) {
    Platform["UNKNOWN"] = "UNKNOWN";
    Platform["REACT_SDK"] = "REACT_SDK";
    Platform["SOLANA_WALLET_ADAPTER"] = "SOLANA_WALLET_ADAPTER";
})(Platform = exports.Platform || (exports.Platform = {}));
//# sourceMappingURL=types.js.map